var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { newAccountId, newCurrencyId, newMonetaryAmount } from "../utils";
import { parseOrmlTokensAccountData } from "../types";
export class DefaultTokensAPI {
    constructor(api) {
        this.api = api;
    }
    total(currency) {
        return __awaiter(this, void 0, void 0, function* () {
            const currencyId = newCurrencyId(this.api, currency);
            const rawAmount = yield this.api.query.tokens.totalIssuance(currencyId);
            return newMonetaryAmount(rawAmount.toString(), currency);
        });
    }
    getAccountData(currency, id) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.api.query.tokens.accounts(id, newCurrencyId(this.api, currency));
        });
    }
    balance(currency, id) {
        return __awaiter(this, void 0, void 0, function* () {
            const accountData = yield this.getAccountData(currency, id);
            return parseOrmlTokensAccountData(accountData, currency);
        });
    }
    subscribeToBalance(currency, account, callback) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const accountId = newAccountId(this.api, account);
                const unsubscribe = yield this.api.query.tokens.accounts(accountId, newCurrencyId(this.api, currency), (accountData) => {
                    callback(account, parseOrmlTokensAccountData(accountData, currency));
                });
                return unsubscribe;
            }
            catch (error) {
                Promise.reject(error);
            }
            // as a fallback, return an empty void function
            return () => {
                return;
            };
        });
    }
    buildTransferExtrinsic(destination, amount) {
        const amountAtomicUnit = this.api.createType("Balance", amount.toString(true));
        return this.api.tx.tokens.transfer(destination, newCurrencyId(this.api, amount.currency), amountAtomicUnit);
    }
    transfer(destination, amount) {
        const amountAtomicUnit = this.api.createType("Balance", amount.toString(true));
        const transferTransaction = this.api.tx.tokens.transfer(destination, newCurrencyId(this.api, amount.currency), amountAtomicUnit);
        return { extrinsic: transferTransaction, event: this.api.events.tokens.Transfer };
    }
    setBalance(accountId, freeBalance, lockedBalance) {
        lockedBalance = lockedBalance ? lockedBalance : newMonetaryAmount(0, freeBalance.currency);
        const tx = this.api.tx.sudo.sudo(this.api.tx.tokens.setBalance(accountId, newCurrencyId(this.api, freeBalance.currency), freeBalance.toString(true), lockedBalance.toString(true)));
        return { extrinsic: tx, event: this.api.events.tokens.BalanceSet };
    }
}
//# sourceMappingURL=tokens.js.map